import axios from 'axios';
import apiConfig from '../api.config';

export default function getHotelsPaymentSelected() {
  const {
    host,
    URIs: { hotelsSelectedPayment },
  } = apiConfig;

  const uri = `${host}${hotelsSelectedPayment}`;

  return axios
    .get(uri, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
